import { logError } from "@/lib/error-handling";
import { apiClient } from "@/services/api";
import { MyScheduleResponseDto, ScheduleDayCountsResponseDto } from "@/types";

function browserTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

/**
 * Fetches the current user's schedule for one day in the browser's time zone.
 * Defaults to today when no date is given.
 */
export async function fetchMySchedule(
  date?: string
): Promise<MyScheduleResponseDto> {
  try {
    const tz = browserTimeZone();
    const requestedDate =
      date ??
      new Intl.DateTimeFormat("en-CA", { timeZone: tz }).format(new Date());
    return await apiClient<MyScheduleResponseDto>("/api/me/schedule", {
      params: { date: requestedDate, tz },
    });
  } catch (error) {
    logError(error, "fetchMySchedule");
    throw error;
  }
}

/** Fetches per-day meeting counts for the navigator strip's date range. */
export async function fetchScheduleDayCounts(
  from: string,
  to: string
): Promise<ScheduleDayCountsResponseDto> {
  try {
    return await apiClient<ScheduleDayCountsResponseDto>(
      "/api/me/schedule/counts",
      { params: { from, to, tz: browserTimeZone() } }
    );
  } catch (error) {
    logError(error, "fetchScheduleDayCounts");
    throw error;
  }
}
